export default __webpack_public_path__ + "static/media/img_fee_20.0c987a9d.svg";